import { getTelephonyErrorMessage } from "./telephonyErrorMessages";

/**
 * Connects browser phone (if needed) and places an outbound call.
 * Shows a user-friendly toast when the call cannot be placed (e.g. off office network).
 */
export const placeBrowserCall = async ({
  actions,
  phoneNumber,
  options = {},
  toast,
  t,
  providerName,
  rethrow = false,
}) => {
  const trimmed = String(phoneNumber || "").trim();
  if (!trimmed) {
    const message = t("ccPhoneNumberRequired");
    toast?.error(message);
    if (rethrow) throw new Error(message);
    return false;
  }

  try {
    await actions.connect();
    if (typeof actions.ensurePhoneReady === "function") {
      await actions.ensurePhoneReady();
    }
    await actions.startCall(trimmed, options);
    return true;
  } catch (error) {
    toast?.error(getTelephonyErrorMessage(error, t, { providerName }));
    if (rethrow) throw error;
    return false;
  }
};

export const connectBrowserPhone = async ({ actions, toast, t, providerName, rethrow = false }) => {
  try {
    await actions.connect();
    return true;
  } catch (error) {
    toast?.error(getTelephonyErrorMessage(error, t, { providerName }));
    if (rethrow) throw error;
    return false;
  }
};

export const runTelephonyAction = async ({ action, toast, t, providerName, rethrow = false }) => {
  try {
    await action();
    return true;
  } catch (error) {
    toast?.error(getTelephonyErrorMessage(error, t, { providerName }));
    if (rethrow) throw error;
    return false;
  }
};
